import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, Spinner } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import UserRole from "./UserRole";
import { approveUser } from "common/services/users.service";
import { toast } from "react-toastify";

const ApproveUser: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchUsers: () => void;
  user: any;
}> = ({ toggle, isModalOpen, fetchUsers, user }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      role: {
        value: "",
        label: "",
      },
    },
    validationSchema: Yup.object({
      role: Yup.object().shape({
        value: Yup.number().required("Please select role"),
      }),
    }),
    onSubmit: async (values) => {
      if (!user?.id) return;
      setLoading(true);
      try {
        await approveUser({ user: user.id, role: values.role.value });
        validation.resetForm();
        toggle();
        toast.success("User approved successfully.", { autoClose: 500 });
        fetchUsers();
      } catch (e: any) {
        toast.error("Error while approving user.", { autoClose: 500 });
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="approveUserModal"
      size="md"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Approve User
      </ModalHeader>
      <form
        className="tablelist-form"
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <ModalBody>
          <p className="text-muted mb-3"> Select a role for this user</p>
          <div className="mb-3">
            <UserRole validation={validation} />
          </div>
        </ModalBody>

        <div className="modal-footer">
          <div className="hstack gap-2 justify-content-end">
            <button type="button" className="btn btn-light" onClick={toggle}>
              Close
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading && (
                <Spinner
                  color="light"
                  size="sm"
                  style={{ marginRight: "8px", marginBottom: "-1px" }}
                ></Spinner>
              )}
              Approve
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default ApproveUser;
